export const commonPaths = {
  static: {
    root: '/',
    notFound: '/404',
    taskPublic: '/public/tasks',
    publicDocument: '/public/document',
    publicFolder: '/public/folder',
    sales: '/sales_department',
    incidentReporting: '/event_reporting',
    taskForceLogin: '/public/tasks/force-login',
  },
  dynamic: {
    task(id?: string | number) {
      return `/tasks/${id || ':id'}`;
    },
    publicDocument(id?: string | number) {
      return `/public/document/${id || ':id'}`;
    },
    publicFolder(id?: string | number) {
      return `/public/folder/${id || ':id'}`;
    },
  },
};

export const publicPages = [
  commonPaths.static.taskPublic,
  commonPaths.static.notFound,
  commonPaths.static.publicDocument,
  commonPaths.static.publicFolder,
  commonPaths.dynamic.publicDocument(),
  commonPaths.dynamic.publicFolder(),
];
